import { create } from './create';

export const successfulClaims = { create };
